"use strict";

exports.__esModule = true;
exports.ChunkExtractor = exports.ChunkExtractorManager = void 0;
var _ChunkExtractorManager = _interopRequireDefault(require("./ChunkExtractorManager"));
exports.ChunkExtractorManager = _ChunkExtractorManager.default;
var _ChunkExtractor = _interopRequireDefault(require("./ChunkExtractor"));
exports.ChunkExtractor = _ChunkExtractor.default;
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}